<template>
  <div class="page noselect pageAsOverlay">
    <AppHead v-if="$store.getters.showDialogContainer" @menu="$ebus.$emit('goBack')"></AppHead>

    <!--        <div class="absBack">-->
    <!--            <div onclick="window.history.back()">-->
    <!--                <v-icon  medium dark>mdi-arrow-left</v-icon>-->
    <!--            </div>-->
    <!--        </div>-->

    <!--        <h1 class="myTitle">AGB</h1>-->

    <v-container grid-list-md>
      <div class="text-left mt-7">
        <h2>Allgemeine Geschäftsbedingungen</h2>
        <div class="spacer-15"></div>
        <CmsBlock blockName="AGB"></CmsBlock>
        <!--                <div>-->
        <!--                    <a href="http://demo1.appcoast.eu/impressum/"-->
        <!--                       target="_blank">http://demo1.appcoast.eu/impressum/</a>-->
        <!--                </div>-->
      </div>
      <!--            <iframe id="datenschutzIframe" style="height: 487px; width: 100%; background-color: transparent;" scrolling="no"-->
      <!--                    :src="url"-->
      <!--                    sandbox="allow-forms allow-same-origin allow-scripts allow-modals allow-popups"-->
      <!--                    frameborder="0"></iframe>-->
    </v-container>

    <div class="fixed-continue" v-if="$store.getters.showDialogContainer">
      <v-container>
        <div class="text-center">
          <v-btn class="btn-df" @click.native.passive="$ebus.$emit('goBack')">
            Zurück zur Bestellung
          </v-btn>
        </div>
      </v-container>
    </div>
  </div>
</template>

<script>
// import * as iframe from "../iframe/handleFrameUpdates"
// import {logPageView} from "../firebase/firebaseUtil";

import AppHead from "@/components/AppHead";
import {ebus} from "@/vendor/ebus";
import CmsBlock from "@/components/CmsBlock";
import {jumpToTop} from "@/vendor/util";
import store from "../store/store";

export default {
  name: "Agb",
  components: {CmsBlock, AppHead},

  computed: {
    url() {
      // return 'https://static.qsignal.eu/sudhauswarstein/legal/agb.html'
      return 'https://' + window.location.host + '/legal/agb.html'
    }
  },

  mounted() {
    store.commit('showLoading', false);

    jumpToTop(true);

    // let _this = this;
    // this.processSizeUpdate = function (e) {
    //   try {
    //     console.log('got some message: ' + JSON.stringify(e));
    //     var myIframe = document.getElementById('agbIframe');
    //     if (myIframe.src && myIframe.src.indexOf(e.origin) === 0) {
    //       try {
    //         var data = JSON.parse(e.data);
    //         console.log('raw data = ' + e.data);
    //
    //         if (data.event === 'iframeHeight') {
    //           _this.iframeLoaded = true;
    //           myIframe.style.height = (data.height + 40) + 'px';
    //           console.log('iframe height has been updated');
    //         } else if (data.event === 'gotoSortiment') {
    //           _this.$router.push({name: 'Sortiment'});
    //         }
    //       } catch (e) {
    //         alert('Parsing error: ' + e);
    //         console.log('error: ', e);
    //       }
    //     }
    //   } catch (e) {
    //     // alert('Uups parsing rawData error: ' + e);
    //     console.log('Uups parsing rawData error: ' + e);
    //   }
    // };
    // window.addEventListener("message", this.processSizeUpdate, false);
  },

  destroyed() {
    try {
      window.removeEventListener("message", this.processSizeUpdate);
    } catch (e) {
      console.log('Error removing processSizeUpdate: ' + e.message);
    }

  },
}
</script>

<style scoped lang="scss">
.fixed-continue {
  position: fixed;
  bottom: 15px;
  left: 0;
  width: 100%;
}
</style>
